<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">科室</div>
            <el-select v-model="edit_DepartmentId" placeholder="请选择科室" style="width: 100%">
              <el-option
                  v-for="item in departmentList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">收支项目名称</div>
            <el-input v-model="edit_Name" placeholder="请输入收支项目名称" ></el-input>
          </el-col>
        </el-row>

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">收支类型</div>
            <el-select v-model="edit_Type" placeholder="请选择收支类型" style="width: 100%;">
              <el-option
                  v-for="item in type_arr"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-col>
<!--          <el-col :span="12" class="item">-->
<!--            <div class="label">状态</div>-->
<!--            <el-select v-model="edit_Status" placeholder="请选择状态" style="width: 100%;">-->
<!--              <el-option-->
<!--                  v-for="item in status_arr"-->
<!--                  :key="item.label"-->
<!--                  :label="item.label"-->
<!--                  :value="item.value">-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--          </el-col>-->
          <el-col :span="12" class="item">
            <div class="label">排序</div>
            <el-input v-model="edit_Sort" placeholder="请输入排序"></el-input>
          </el-col>
        </el-row>

      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm">提交</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Edit',
  props: [],
  data() {
    return {

      loading: false,

      edit_Name:'',
      edit_Sort:'',
      edit_DepartmentId:'',
      edit_DepartmentInOutId:'',
      edit_Type:'',
      //edit_Status:'',

      departmentList:[],
      type_arr:[{value:'in',label:'收入'},{value:'out',label:'支出'}],
      //status_arr:[{value:1,label:'正常'},{value:2,label:'禁用'}],

    }
  },
  methods: {
    init(row){

      this.edit_Name = row.name;
      this.edit_Sort = row.sort;
      //this.edit_Status = row.status;
      this.edit_DepartmentId=row.departmentId;
      this.edit_DepartmentInOutId=row.id;
      this.edit_Type=row.type;

      this.getDepartmentList();

    },

    closeSelf() {
      this.$emit("closeEdit");
    },



    getDepartmentList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'Department/AdmList',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.departmentList = response.data.data.list;

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    confirm(){

      if(this.edit_Name === ''){
        this.$message("输入收支项目名称");
        return;
      }
      if(this.edit_Sort === ''){
        this.$message("输入排序");
        return;
      }
      if(this.edit_DepartmentId === ''){
        this.$message("选择科室");
        return;
      }
      if(this.edit_Type === ''){
        this.$message("选择收支类型");
        return;
      }



      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'DepartmentInOut/AdmEdit',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          name: this.edit_Name,
          sort:this.edit_Sort,
          status:1,
          departmentId:this.edit_DepartmentId,
          departmentInOutId:this.edit_DepartmentInOutId,
          type:this.edit_Type,
        }
      }).then( (response)=> {
        //console.log(response)
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeEdit");
          this.$emit("getList");
        }else{
          this.$message(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


  }
}
</script>

